import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-10 max-w-7xl mx-auto">
        <div className="relative rounded-3xl overflow-hidden bg-gradient-to-br from-primary-600 via-primary-700 to-primary-800">
          <div className="absolute inset-0 opacity-10">
            <img
              src="https://readdy.ai/api/search-image?query=Abstract%20geometric%20pattern%20with%20soft%20flowing%20lines%20and%20subtle%20texture%2C%20dark%20background%20with%20golden%20highlights%2C%20elegant%20modern%20design%2C%20minimal%20and%20sophisticated&width=1600&height=600&seq=cta-bg-pattern&orientation=landscape"
              alt=""
              className="w-full h-full object-cover"
            />
          </div>
          <div className="relative z-10 px-6 py-14 md:py-20 text-center">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold font-heading text-white mb-4">
              准备好开始了吗？
            </h2>
            <p className="text-white/80 text-sm md:text-base mb-8 max-w-lg mx-auto">
              立即完成 <strong>2pg·com 注册</strong>，领取专属新人福利，开启您的畅玩之旅
            </p>
            <Link
              to="/about"
              className="inline-flex items-center px-8 py-3.5 rounded-full text-base font-semibold bg-white text-primary-700 hover:bg-background-100 transition-all whitespace-nowrap cursor-pointer"
            >
              立即注册开户
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}